module.exports = __webpack_public_path__ + "static/media/HospedeCosta10.881fba83.jpeg";